


















import {Component, Vue, Watch} from "vue-property-decorator";
import OrderService from "@/service/OrderService";
import {PaginatedOrders} from "@/api/Order";
import OrderSummaryView from "@/components/Dashboard/Orders/OrderSummaryView.vue";
import RenderPager from "@/components/Shared/RenderPager.vue";
import Loading from "@/components/Shared/Loading.vue";
import RenderEmpty from "@/components/Shared/RenderEmpty.vue";

@Component({
  components: {RenderEmpty, Loading, RenderPager, OrderSummaryView}
})
export default class OrdersList extends Vue {
  private orders: PaginatedOrders | null = null;
  private hasFilter = false;

  public async getOrders() {
    let pageNumber = 1;
    if(this.$route.query.p) {
      pageNumber = parseInt(this.$route.query.p.toString());
    }
    let filter = "pending";
    if(this.$route.query.filter) {
      filter = this.$route.query.filter.toString();
      this.hasFilter = true;
    }else{
      this.hasFilter = true;
    }
    this.$store.dispatch('loading/showLoadingModal');
    this.orders = await OrderService.getPaginatedOrders(pageNumber, filter);
    this.$store.dispatch('loading/hideLoadingModal');
  }

  async mounted() {
    await this.getOrders()
  }

  @Watch('$route.query')
  onRouteChanged() {
    this.getOrders();
    window.scrollTo(0,0);
  }

  get emptyMessage(){
    if(this.hasFilter){
      return "شما سفارشی در این بخش ندارید."
    }
    return "شما هنوز هیچ سفارشی ثبت نکرده‌اید";
  }
}
